export default __webpack_public_path__ + "static/media/816-solar-pros-logo.11410652.png";